// Return WordPress data for specific page
export const getPageData = (data, pageName) => {
  let dataObj = {}

  // Loop over all WordPress pages
  data.allWordpressPage.edges.map(page => {
    const { page_reference } = page.node.acf

    if (page_reference === pageName) {
      dataObj = page.node.acf
    }
  })

  return dataObj
}

// Destructure and return Image source
export const getImageSrc = image =>
  image.localFile.childImageSharp.sizes.originalImg

// Scroll page when Hero Button is clicked
export const scrollToDiv = id => {
  const element = document.getElementById(id)

  element.scrollIntoView({ block: 'start', behavior: 'smooth' })
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js